import styled from 'styled-components'

export const PoolPanelStyle = styled.div<{ isLoaded: boolean }>`
  display: flex;
  justify-content: center;
  align-self: center;
  border: 0rem solid ${({ theme }) => theme.poolPanelBorderColor};
  text-align: center;
  padding: 2rem;
  padding-bottom: 10rem;
  box-shadow: ${({ theme }) => theme.poolPanelShadow};

  table {
    align-self: center;
    font-family: Montserrat;
    border-spacing: 0;
    color: ${({ theme }) => theme.poolPanelTextColor};
    font-size: 1.75rem;
    background-color: ${({ theme, isLoaded }) =>
      isLoaded ? theme.poolPanelBackgroundColor : 'inherited'};
    padding: 0 2rem;

    /* Tablets */
    @media (max-width: 1400px) {
      font-size: 1.75rem;
    }

    /* Mobiles */
    @media (max-width: 640px) {
      font-size: 1.5rem;
    }

    tr {}

    th {
      opacity:1; 
      font-family: Montserrat-Light;
      font-size: 1.35rem;
    },
    td {
      margin: 0;
      border: 0px solid black;
      padding: 2rem;
      padding-top: 3rem;
      padding-bottom: 1rem;
      vertical-align:top;
      justify-content:center;
      justify-items:center;
      align-self:center;

      /* Tablets */
      @media (max-width: 1400px) {
        padding: 1.5rem;
      }

      /* Mobiles */
      @media (max-width: 640px) {
        padding: 1rem;
      }

      :last-child {
        border-right: 0;
        border-right-style: solid;
        border-bottom-right-radius: 2rem;
        border-top-right-radius: 5rem;
      }
      :first-child {
        border-left-style: solid;
        border-top-left-radius: 5rem;
        border-bottom-left-radius: 2rem;
      }
    }
  }
`
